import { MultiSelect } from "primereact/multiselect";
import { IAssetTypes } from "../models/asset";
import { useEffect } from "react";

interface ISubGroupMultiSelectProps {
    selectedGroupFamily?: string[];
    assets: IAssetTypes[];
    value: string[];
    onChange: (value: string[]) => void;
    onChangeSelectedLabel?: (label: string) => void;
}

const SubGroupMultiSelect = ({ selectedGroupFamily = [], assets, value, onChange, onChangeSelectedLabel }: ISubGroupMultiSelectProps) => {
    const options = [
        {
            label: "Renda fixa",
            items: assets.filter(a => a.asset_family === "F"),
            family: ["F"]
        },
        {
            label: "Renda variável",
            items: assets.filter(a => a.asset_family === "V" || a.asset_family === "T" || a.asset_family === "U"),
            family: ["V", "T", "U"]
        },
        {
            label: "Em caixa",
            items: assets.filter(a => a.asset_family === "C"),
            family: ["C"]
        },
        {
            label: "Imóveis",
            items: assets.filter(a => a.asset_family === "P"),
            family: ["P"]
        },
        {
            label: "Veículos",
            items: assets.filter(a => a.asset_family === "M"),
            family: ["M"]
        }
    ];

    useEffect(() => {
        const allValuesNotInSelectedGroupFamily = value
            .map(v => assets.find(a => a._id === v)!)
            .filter(a => !selectedGroupFamily.includes(a.asset_family))
            .map(a => a._id);

        if (allValuesNotInSelectedGroupFamily.length > 0) {
            const newValues = value
                .map(v => assets.find(a => a._id === v)!)
                .filter(a => selectedGroupFamily.includes(a.asset_family))
                .map(a => a._id);
            change(newValues);
        }
    }, [selectedGroupFamily]);

    const change = (value: string[]) => {
        onChange(value);
        if (value.length === 0) {
            onChangeSelectedLabel?.("");
            return;
        }

        if (value.length > 2) {
            onChangeSelectedLabel?.(`${value.length} selecionados`);
            return;
        }

        onChangeSelectedLabel?.((value as string[]).map(subGroupIds => assets.filter(a => subGroupIds.includes(a._id)).map(a => a.asset_name)).join(", "));
    }

    return (
        <MultiSelect 
            filter
            value={value} 
            onChange={(e) => {
                change(e.value);
            }} 
            options={options.filter(o => selectedGroupFamily.length === 0 || selectedGroupFamily.some(f => o.family.includes(f)))} 
            optionLabel="asset_name"
            optionGroupLabel="label"
            optionGroupChildren="items" 
            optionValue="_id"
            placeholder="Selecione os subgrupos" 
            maxSelectedLabels={2} 
            className="w-full" 
        />
    )
}

export default SubGroupMultiSelect;